import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxValidatorComponent } from 'devextreme-angular';

@Component({
  selector: 'app-date-selection',
  standalone: false,
  templateUrl: './date-selection.component.html',
  styleUrl: './date-selection.component.scss',
})
export class DateSelectionComponent {
  @ViewChild('startDateValidator', { static: false }) 
  startDateValidator!: DxValidatorComponent;

  @ViewChild('endDateValidator', { static: false }) 
  endDateValidator!: DxValidatorComponent;

  @Input()
  minStartDate: Date | null = null;

  @Input()
  maxEndDate: Date | null = null;

  @Input()
  startDate: Date | null = null;

  @Output()
  startDateChange = new EventEmitter<Date | null>();

  @Input()
  endDate: Date | null = null;

  @Output()
  endDateChange = new EventEmitter<Date | null>();
  
  @Input()
  startDateLabel: string | null = null;

  @Input()
  endDateLabel: string | null = null;

  @Input() isViewMode: boolean = false;
  @Input() disabled: boolean = false;

  @Input()
  preventSameDay: boolean = false;

  constructor(public elementRef: ElementRef) {
    
  }

  public validateDates() {
    const isStartDateValid = this.startDateValidator.instance.validate().isValid;
    const isEndDateValid = this.endDateValidator.instance.validate().isValid;

    return isStartDateValid && isEndDateValid;
  }

  public getDates() {
    return {
      start: this.startDate!,
      end: this.endDate!
    }
  }

  onStartDateChanged(value: Date | null) {
    this.startDate = value;
    this.startDateChange.emit(value);
  }

  onEndDateChanged(value: Date | null) {
    this.endDate = value;
    this.endDateChange.emit(value);
  }

  getStartDateMax(): Date | null {
    if (!this.endDate) return this.maxEndDate;

    if (!this.preventSameDay) {
      return this.endDate ?? this.maxEndDate;
    }

    const max = new Date(this.endDate);
    max.setDate(max.getDate() - 1); // force previous day
    return max;
  }

  getEndDateMin(): Date | null {
    if (!this.startDate) return this.minStartDate;

    if (!this.preventSameDay) {
      return this.startDate ?? this.minStartDate;
    }

    const min = new Date(this.startDate);
    min.setDate(min.getDate() + 1); // force next day
    return min;
  }
}
